import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreateDefensivePayload } from '../../../products/types';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';
import { createFormData } from '../helpers/createFormdata';

export const usePostDefensive = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (payload: CreateDefensivePayload) => {
			try {
				console.log(payload);
                const formData = createFormData(payload);
				return (await api.post('/agricultural-defensives/create', formData)).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao criar defensivo');
			}
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ['defensives'] }),
		onError: (error) => {
			console.error(
				'Erro ao criar defensivo:',
				getApiErrorMessage(error, 'Erro ao criar defensivo')
			);
		},
	});
};
